export default {"src":"https://assets.willie.be/003a5d6bcce39278/_next/static/media/fr.2a6e75b7.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};